const UserActionTypes = {
  FETCH_USER_REQUEST: 'FETCH_USER_REQUEST',
  FETCH_USER_SUCCESS: 'FETCH_USER_SUCCESS',
  FETCH_USER_FAILURE: 'FETCH_USER_FAILURE',
  FETCH_USER_INFO_REQUEST: 'FETCH_USER_INFO_REQUEST',
  FETCH_USER_INFO_SUCCESS: 'FETCH_USER_INFO_SUCCESS',
  FETCH_USER_INFO_FAILURE: 'FETCH_USER_INFO_FAILURE'
}

export default UserActionTypes